// Dependency-free (no MMKV/native imports) so consumers needing only a namespace
// — e.g. the E2E auth fixture — can import it without loading the MMKV storage.
export const AUTH_STORAGE_NAMESPACE = "medbillai-auth-state";
